import {ScenarioExecutionAction, ScenarioExecutionActions} from './types';
import {
  FindScenarioExecutionsRequest,
  ScenarioExecutionListDTO,
  ScenarioExecutionGroupListDTO,
  ScenarioExecutionStatusUpdateDTO,
} from 'hemwb-api';
import {buildInitialAsyncState, reduceAsyncAction} from '../asyncUtils';
import {AsyncActionPhase, AsyncActionState} from '../asyncUtilsTypes';

export type ScenarioExecutionState = {
  list: AsyncActionState<ScenarioExecutionListDTO, [FindScenarioExecutionsRequest]>;
  groupByList: AsyncActionState<ScenarioExecutionGroupListDTO, [FindScenarioExecutionsRequest]>;
  lastStatusUpdate: ScenarioExecutionStatusUpdateDTO | null;
};

export const scenarioExecutionInitialState: ScenarioExecutionState = {
  list: buildInitialAsyncState<ScenarioExecutionListDTO>(),
  groupByList: buildInitialAsyncState<ScenarioExecutionGroupListDTO>(),
  lastStatusUpdate: null,
};

export const scenarioExecutionReducer = (
  state = scenarioExecutionInitialState,
  action: ScenarioExecutionAction,
): ScenarioExecutionState => {
  switch (action.type) {
    case ScenarioExecutionActions.REQUEST_LIST: {
      if (action.phase === AsyncActionPhase.START) {
        return {
          ...state,
          list: {...reduceAsyncAction(action), value: state.list.value},
        };
      }
      return {
        ...state,
        lastStatusUpdate: null,
        list: reduceAsyncAction(action),
      };
    }
    case ScenarioExecutionActions.REQUEST_GROUP_LIST: {
      if (action.phase === AsyncActionPhase.START) {
        return {
          ...state,
          groupByList: {...reduceAsyncAction(action), value: state.groupByList.value},
        };
      }
      return {
        ...state,
        lastStatusUpdate: null,
        groupByList: reduceAsyncAction(action),
      };
    }
    case ScenarioExecutionActions.UPDATE_STATUS: {
      const {statusUpdate} = action;
      let updatedState = {
        ...state,
        lastStatusUpdate: statusUpdate,
      };

      // Update in list
      if (state.list.value?.list.some((execution) => execution.id === statusUpdate.id)) {
        updatedState = {
          ...updatedState,
          list: {
            ...state.list,
            value: {
              ...state.list.value,
              list: state.list.value.list.map((execution) =>
                execution.id === statusUpdate.id ? {...execution, ...statusUpdate} : execution,
              ),
            },
          },
        };
      }

      // Update in groupByList (for Execution Queue display)
      // Structure: group.executionDetails[].executions[].id
      if (
        state.groupByList.value?.list.some((group) =>
          group.executionDetails?.some((detail) => detail.executions?.some((ex) => ex.id === statusUpdate.id)),
        )
      ) {
        updatedState = {
          ...updatedState,
          groupByList: {
            ...state.groupByList,
            value: {
              ...state.groupByList.value,
              list: state.groupByList.value.list.map((group) => ({
                ...group,
                executionDetails: group.executionDetails?.map((detail) => ({
                  ...detail,
                  executions: detail.executions?.map((ex) =>
                    ex.id === statusUpdate.id ? {...ex, ...statusUpdate} : ex,
                  ),
                })),
              })),
            },
          },
        };
      }

      return updatedState;
    }
  }
  return state;
};
